module.exports = __webpack_public_path__ + "img/logo.80a1dcfe.png";